var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields,"hover":"","responsive":""},scopedSlots:_vm._u([{key:"cell(email)",fn:function(data){return [_c('div',[_vm._v(_vm._s(data.value[0]))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }